export default __webpack_public_path__ + "static/media/room3-MASK-wood-rot30.36b6f6d6.png";